/**
 * 配列の最初のデータを取得する
 * @param array
 * @param defaultValue
 * @returns {*}
 */
export const arrayFirst = (array, defaultValue = null) => {
    if (Array.isArray(array) && array.length > 0) {
        return array[0];
    }
    return defaultValue;
};
/**
 * 条件に一致する配列の最初のデータを取得する
 * @param array
 * @param key
 * @param value
 * @param defaultValue
 * @returns {*}
 */
export const arrayFirstWhere = (array, key, value, defaultValue = null) => {
    if (Array.isArray(array) && array.length > 0) {
        const firstObj = array.find((obj) => obj[key] === value);
        if (firstObj) {
            return firstObj;
        }
    }
    return defaultValue;
};
/**
 * mapした結果で条件に一致する配列の最初のデータを取得する
 * @param array
 * @param callback
 * @returns {null|*}
 */
export const arrayMapFirst = (array, callback) => {
    const keys = Object.keys(array);
    for (let i = 0; i < keys.length; i += 1) {
        const result = callback(array[keys[i]]);
        if (result) {
            return result;
        }
    }
    return null;
};
/**
 * objectをdot keyの配列にする
 * @param obj
 * @param prefixKey
 * @param newObj
 * @param judgeArray
 */
export const toDotArray = (obj, prefixKey = '', newObj = {}, judgeArray = false) => {
    Object.keys(obj).forEach((objKey) => {
        const objValue = obj[objKey];
        if (typeof objValue !== 'undefined') {
            if (typeof objValue === 'object' || Array.isArray(objValue)) {
                let setKey = `${prefixKey}${objKey}.`;
                if (judgeArray && objKey.match(/^([1-9]\d*|0)$/)) {
                    const forArrayPrefixKey = prefixKey.replace(/\.$/, '');
                    setKey = `${forArrayPrefixKey}[${objKey}].`;
                }
                toDotArray(objValue, setKey, newObj, judgeArray);
            }
            else {
                // eslint-disable-next-line no-param-reassign
                newObj[`${prefixKey}${objKey}`] = objValue;
            }
        }
    });
    return newObj;
};
/**
 * 配列ソート用の計算関数
 * @param a
 * @param b
 * @param key 下記のいずれか。
 *   1. オブジェクトの対象キー名
 *   2. { name: 対象キー名, adjust: 1(昇順) or -1（降順） }
 *   3. { name: オブジェクトから値を取得する関数, adjust: 1(昇順) or -1（降順） }
 * @returns {number}
 */
export const arraySortFunc = (a, b, key) => {
    const name = typeof key === 'string' ? key : key.name;
    let aValue;
    let bValue;
    if (typeof name === 'function') {
        aValue = name(a);
        bValue = name(b);
    }
    else {
        aValue = a[name];
        bValue = b[name];
    }
    const adjust = key.adjust || 1;
    if (aValue === bValue) {
        return 0;
    }
    return (aValue > bValue ? 1 : -1) * adjust;
};
/**
 * 配列ソート用の計算関数（キーの複数指定）
 * @param a
 * @param b
 * @param keys
 * @returns {number}
 */
export const arraySortFuncMultiKeys = (a, b, keys) => {
    for (let i = 0; i < keys.length; i += 1) {
        const result = arraySortFunc(a, b, keys[i]);
        if (result) {
            return result;
        }
    }
    return 0;
};
/**
 * objectに対してarrayのようにmapする関数
 * @param object
 * @param fn
 * @param defaultOptions
 * @param defaultSeen
 * @returns {*}
 */
export const mapObj = (object, fn, defaultOptions, defaultSeen) => {
    const isObject = (x) => typeof x === 'object' &&
        x !== null &&
        !(x instanceof RegExp) &&
        !(x instanceof Error) &&
        !(x instanceof Date);
    const options = Object.assign({ deep: false, target: {} }, defaultOptions);
    const seen = defaultSeen || new WeakMap();
    if (seen.has(object)) {
        return seen.get(object);
    }
    seen.set(object, options.target);
    const { target } = options;
    delete options.target;
    const mapArray = (array) => array.map((x) => (isObject(x) ? mapObj(x, fn, options, seen) : x));
    if (Array.isArray(object)) {
        return mapArray(object);
    }
    // eslint-disable-next-line no-restricted-syntax
    for (const key of Object.keys(object)) {
        const value = object[key];
        // eslint-disable-next-line prefer-const
        let [newKey, newValue] = fn(key, value, object);
        if (options.deep && isObject(newValue)) {
            newValue = Array.isArray(newValue)
                ? mapArray(newValue)
                : mapObj(newValue, fn, options, seen);
        }
        target[newKey] = newValue;
    }
    return target;
};
